<div class="columns is-multiline">
  <div class="column is-12">
    <ag-page-title>{{ title }}</ag-page-title>
  </div>
  <div class="column is-12">
    <ag-shimmer-loader></ag-shimmer-loader>
  </div>
</div>